skrilla.controller('reportProductFeeDetailsCtrl', function ($scope, $stateParams, searchService, productFeeReportService, modalService, srefService) {

    $scope.showTable = false;

    function get() {
        searchService.get("reports/" + $stateParams.id, null, true).then(function (response) {
            $scope.report = response.data;
            $scope.showTable = response.data.entriesAsCsv.split("\n").length <= 501;
            $scope.tableData = productFeeReportService.buildTableForEntries($scope.report.entriesAsCsv);
            $scope.recalculatedTableData.data = $scope.report.testReports;
        })
    }
    get();
    function clickRow(report, event){
        srefService.go("reportDetails", {id: report.id}, event);
    }

    $scope.recalculatedTableData = {
        columns: [
            {title: "Notes", field: "masterNote"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}}
        ],
        rows: {orderBy: "-createdAt", onClick: clickRow, style: "cursor: pointer;"},
        isSkrillaTable: true,
        data: []
    }

    $scope.recalculate = function(){
        modalService.confirm("Are you sure you'd like to trigger a recalculation?", function(){
            searchService.post("reports/" + $stateParams.id +"/recalculate", null, true).then(function(response){
                get();
            })
        })
    }

    $scope.promote = function(){
        modalService.confirm("Are you sure you'd like to promote this to the official report?", function(){
            searchService.put("reports/" + $stateParams.id +"/promote", null, true).then(function(response){
                get();
            })
        })
    }

    $scope.delete = function(){
        modalService.confirm("Are you sure you'd like to delete this report??", function(){
            searchService.deleteRequest("reports/" + $stateParams.id, null, true).then(function(response){
                srefService.go("reports")
            })
        })
    }

    $scope.csv = function(){
        download($scope.report.entriesAsCsv, $scope.report.csvName, "csv")
    }

    function download(data, filename, type) {
        var file = new Blob([data], {type: type});
        if (window.navigator.msSaveOrOpenBlob) // IE10+
            window.navigator.msSaveOrOpenBlob(file, filename);
        else { // Others
            var a = document.createElement("a"),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    }

    $scope.showTableFn = function() {
        $scope.showTable = confirm("Are you sure you want to render this table? It could take a long time")
    }

});
